// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddContactController from "./add_contact_controller";
import NotificationController from "./notification_controller";
import WtAttemptController from "./wt_attempt_controller";
import CurrentTimeController from "./current_time_controller";
import AircraftPositionController from "./aircraft_position_controller";

application.register("add-contact", AddContactController);
application.register("notification", NotificationController);
application.register("wt-attempt", WtAttemptController);
application.register("current-time", CurrentTimeController);
application.register("aircraft-position", AircraftPositionController);